import { Application } from "./core/Application.js";

const app = new Application();
app.init();
